document.addEventListener("dblclick", (event) => {
  const figure = event.target.closest("figure.attachment");
  const editorElement = event.target.closest("trix-editor");
  if (!figure || !editorElement) return;

  window.setTimeout(() => {
    const saveButton = editorElement.toolbarElement && editorElement.toolbarElement.querySelector(".cs2n-trix-table-editor__save");
    if (saveButton) saveButton.disabled = false;
  }, 0);
});
